import "./TouchpointsButton.scss";

const TouchpointsButton: React.FC = () => {
  return (
    <button className="touchpoints-wrapper sr-app-touchpoints-button">
      How can we improve SimpleReport?
    </button>
  );
};

export default TouchpointsButton;
